/** Lightweight match-level tower performance. Survives sell until match ends. */
export interface TowerPerformanceRecord {
  towerId: string
  definitionId: string
  /** Actual effective damage dealt (no overkill). Shield absorption counts. */
  damageDealt: number
  kills: number
  shotsFired: number
  /** Primary successful impacts (Cannon: once per projectile). */
  hits: number
  /** Additional enemies damaged by splash (not including primary). */
  splashHits: number
  /** Frost (and later status) applications/refreshes. */
  statusApplications: number
  /** Armor Break applications/refreshes attributed to this tower. */
  armorBreakApplications: number
  /** Simulated seconds Armor Break was active from applications by this tower. */
  armorBreakUptime: number
  /**
   * Extra damage dealt by any tower while this tower's Armor Break was active,
   * vs the same hit resolved against unbroken armor. Ownership = last applier
   * (status sourceTowerId). Scaled to actual dealt (no overkill fabrication).
   */
  damageAmplifiedByArmorBreak: number
  sold: boolean
  totalInvested: number
}

export function createTowerPerformance(
  towerId: string,
  definitionId: string,
  totalInvested: number
): TowerPerformanceRecord {
  return {
    towerId,
    definitionId,
    damageDealt: 0,
    kills: 0,
    shotsFired: 0,
    hits: 0,
    splashHits: 0,
    statusApplications: 0,
    armorBreakApplications: 0,
    armorBreakUptime: 0,
    damageAmplifiedByArmorBreak: 0,
    sold: false,
    totalInvested
  }
}

export type DamageKind = 'direct' | 'splash' | 'dot'

export interface DamageSource {
  towerId?: string
  projectileId?: string
  kind: DamageKind
}

export interface ApplyDamageResult {
  dealt: number
  killed: boolean
}
